// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoMacchina.
export const STATI_MACCHINA = [
    { label: "Attiva", value: "Attiva" },
    { label: "In manutenzione", value: "InManutenzione" },
    { label: "Fuori servizio", value: "FuoriServizio" },
    { label: "Dismessa", value: "Dismessa" },
];

const COLORI_STATO = {
    Attiva: "success",
    InManutenzione: "warning",
    FuoriServizio: "error",
    Dismessa: "grey",
};

export function coloreStato(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStato(stato) {
    return (STATI_MACCHINA.find(s => s.value === stato) || {}).label || "";
}
